
define('text!templates/modules/questionnaire/questions/list/options/option-list-item.html',[],function () { return '<div class="urow">\n    <div class="ucol option">\n        <div class="option-input"></div>\n    </div>\n    <div class="ucol remove-option">\n        <div class="remove-option-button fa fa-times-circle"></div>\n    </div>\n</div>\n';});

